import { cva, type VariantProps } from 'class-variance-authority';

export const inputVariants = cva(
    'h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
    {
        variants: {
            variant: {
                default: '',
                inline: 'h-auto rounded-none border-0 bg-transparent p-0 text-xs shadow-none transition-none outline-none focus:border-0 focus:ring-0 focus:outline-none focus-visible:border-0 focus-visible:ring-0 focus-visible:outline-none md:text-xs dark:bg-transparent',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export type InputVariants = VariantProps<typeof inputVariants>;
export type InputVariant = InputVariants['variant'];
